@if (open) {
<div class="perfil-salir-modal" role="dialog" aria-modal="true" aria-labelledby="perfil-salir-title"
  (click)="onBackdrop($event)">
  <div class="perfil-salir-modal__panel" (click)="$event.stopPropagation()">
    <header class="perfil-salir-modal__header">
      <span class="perfil-salir-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="perfil-salir-modal__title" id="perfil-salir-title">
        {{ copy.titulo }}
      </h2>
      <button type="button" class="perfil-salir-modal__close" aria-label="Cerrar" (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="perfil-salir-modal__body">
      <p class="perfil-salir-modal__text">
        {{ copy.cuerpoAntes }}
        <strong class="perfil-salir-modal__em">{{ copy.cuerpoEnfasis }}</strong>
        {{ copy.cuerpoDespues }}
      </p>
      <button type="button" class="perfil-salir-modal__cta" id="btn-perfil-salir-guardar" (click)="onGuardar()">
        <span>{{ copy.ctaGuardar }}</span>
        <span class="material-icons-outlined perfil-salir-modal__cta-icon" aria-hidden="true">sentiment_satisfied</span>
      </button>
    </div>
  </div>
</div>
}
